import { Injectable } from '@angular/core';
import { ApiService } from '../API/api.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
  })
  export class CustomerService {
    constructor(public apiService: ApiService) { }
    private messageSource = new BehaviorSubject({});
  
    currentEditCustomer = this.messageSource.asObservable();  
    //  addPageCustomerNum = this.messageSource.asObservable();
    editCustomer(data: any){
        this.messageSource.next(data)
    }
    getAllCustomers(body: any): Observable<any> {
        return this.apiService.post('customers/getCustomers',body);
    }
    addCustomers(body : any): Observable<any> {
        return this.apiService.post('customers/createCustomer',body);
    }
    
    importCustomerExcel(body : any): Observable<any> {
        return this.apiService.post('customers/importCustomerExcel',body);
    }
    editCustomers(body : any): Observable<any> {
        return this.apiService.post('customers/editCustomer',body);
    }
    beforeNewCreation(body :  any): Observable<any> {
        return this.apiService.post('customers/beforeNewCreation',body);
    }
    deleteCustomer(body :  any, param : any): Observable<any> {
        return this.apiService.put('customers/deleteCustomer', param, body);
    }
    contactReviewCustomer(body:any, param:any): Observable<any> {
        return this.apiService.put('customers/contactReview', param, body);
    }

}  